import React, { createContext, PropsWithChildren } from 'react';
import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import { LoggedUser, OpenLoginType } from './MainProvider.types';
import { useStorage, Permissions } from '../hooks';

export const MainContext = createContext<{
  openLogin?: OpenLoginType,
  loggedUser?: LoggedUser,
  permissions?: Permissions,
  isMobile?: boolean,
  isTablet?: boolean,
  isSmartTV?: boolean,
  lang?: string,
  tracker?: any,
  company?: any,
  platforms?: string;
  platformType?: string;
}>({});

export type GetClient = ({ lang, tryGuestLogin }: { lang?: string; tryGuestLogin?: any }
) => { client: ApolloClient<NormalizedCacheObject> };

export interface MainProviderProps extends PropsWithChildren {
  openLogin?: OpenLoginType;
  loggedUser?: LoggedUser,
  client?: ApolloClient<NormalizedCacheObject>;
  getClient?: GetClient;
  isMobile?: boolean;
  isTablet?: boolean;
  isSmartTV?: boolean;
  lang?: string;
  tracker?: any;
  company?: any;
  tryGuestLogin?: any;
  platforms?: string;
  platformType?: string;
}

export const MainProvider: React.FC<MainProviderProps & { finalClient: any }> = ({
  finalClient,
  children,
  ...props
}) => {
  const { getPermissions } = useStorage();
  const permissions = getPermissions();

  return (
    <MainContext.Provider value={{ ...props, permissions }}>
      <ApolloProvider client={finalClient}>
        {children}
      </ApolloProvider>
    </MainContext.Provider>
  );
};
